"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useUpdateTableData = function useUpdateTableData(setData) {
  var updateData = (0, _react.useCallback)( // When the cell renderer calls updateData, we'll use
  // the rowIndex, columnId and new value to update the
  // original data
  function (rowIndex, columnId, value) {
    setData(function (old) {
      return old.map(function (row, index) {
        if (index === rowIndex) {
          return _objectSpread(_objectSpread({}, old[rowIndex]), {}, (0, _defineProperty2["default"])({}, columnId, value));
        }

        return row;
      });
    });
  }, [setData]);
  return {
    updateData: updateData
  };
};

var _default = useUpdateTableData;
exports["default"] = _default;
//# sourceMappingURL=useUpdateTableData.js.map